export default __webpack_public_path__ + "static/media/background.55861a54.jpg";